/**
 * @fileoverview CSS module containing transition classes for modal animations.
 * Used in conjunction with React Transition Group to animate modals.
 *
 * @example
 * // Usage with CSSTransition component:
 * <CSSTransition
 *   classNames={{
 *     enter: styles.transition_enter,
 *     enterActive: styles.transition_enter_active,
 *     exit: styles.transition_exit,
 *     exitActive: styles.transition_exit_active
 *   }}
 *   timeout={300}
 * >
 *   <Modal />
 * </CSSTransition>
 */


.transition_enter {
    opacity: 0;
}

.transition_enter_active {
    opacity: 1;
    transition: all 300ms;
}

.transition_exit {
    opacity: 1;
}

.transition_exit_active {
    opacity: 0;
    transition: all 300ms;
}
